import { CACHE_TTL_MS, SPECS } from '../../constants';
var ViewerStorage = /** @class */ (function () {
    function ViewerStorage(_a) {
        var cacheKey = _a.cacheKey, _b = _a.clearOnRefresh, clearOnRefresh = _b === void 0 ? true : _b, storage = _a.storage, siteStore = _a.siteStore;
        var _this = this;
        this.cacheKey = cacheKey;
        this.storage = storage;
        this.siteStore = siteStore;
        if (clearOnRefresh) {
            this.clearOnReload();
            siteStore.location.onChange(function () {
                _this.storage.session.setItem(_this.getLastUrlCacheKey(), _this.siteStore.location.url);
            });
        }
    }
    ViewerStorage.prototype.get = function () {
        var item;
        try {
            item = this.storage.session.getItem(this.cacheKey);
        }
        catch (_a) {
            item = undefined;
        }
        if (!item) {
            return;
        }
        var parsed;
        try {
            parsed = JSON.parse(item);
        }
        catch (_b) {
            return;
        }
        var isExpired = Date.now() - parsed.timestamp > CACHE_TTL_MS;
        if (isExpired ||
            (this.siteStore.experiments.enabled(SPECS.DontUseViewerStorageOnPreview) && this.isPreviewMode())) {
            this.remove();
            return;
        }
        return parsed.item;
    };
    ViewerStorage.prototype.set = function (item) {
        var cachedItem = {
            item: item,
            timestamp: Date.now(),
        };
        try {
            this.storage.session.setItem(this.cacheKey, JSON.stringify(cachedItem));
        }
        catch (_a) {
            this.remove();
        }
    };
    ViewerStorage.prototype.remove = function () {
        this.storage.session.removeItem(this.cacheKey);
    };
    ViewerStorage.prototype.clearOnReload = function () {
        var lastUrlCacheKey = this.getLastUrlCacheKey();
        var url = this.siteStore.location.url;
        var lastUrl;
        var hadError = false;
        try {
            lastUrl = this.storage.session.getItem(lastUrlCacheKey);
        }
        catch (_a) {
            hadError = true;
        }
        var isReload = url === lastUrl;
        if (isReload || hadError) {
            this.remove();
            this.storage.session.removeItem(lastUrlCacheKey);
        }
        this.storage.session.setItem(lastUrlCacheKey, url);
    };
    ViewerStorage.prototype.getLastUrlCacheKey = function () {
        return "".concat(this.cacheKey, "-lastUrl");
    };
    ViewerStorage.prototype.isPreviewMode = function () {
        return new URL(this.siteStore.location.url).searchParams.get('previewMode') === 'true';
    };
    return ViewerStorage;
}());
export { ViewerStorage };
//# sourceMappingURL=ViewerStorage.js.map